interface RangeThumbTooltipProps {
  formattedDisplay: React.ReactNode
}

export const RangeThumbTooltip = ({
  formattedDisplay,
}: RangeThumbTooltipProps) => {
  return (
    <div className='absolute left-1/2 -translate-x-1/2 -top-[40px] bg-white rounded-md'>
      <div className='shadow-[0px_8px_16px_-2px_rgba(27,33,44,0.12)] inline-flex flex-col justify-start items-center rounded-md'>
        <div className='px-2 py-1.5 bg-white rounded-lg inline-flex justify-start items-center gap-1.5'>
          <div className='flex justify-start items-end gap-0.5'>
            <div className='text-blue-950'>{formattedDisplay}</div>
          </div>
        </div>
        <div className='flex flex-col justify-start items-center gap-2.5'>
          <div className='w-4 h-2 bg-white rotate-45' />
        </div>
      </div>
    </div>
  )
}
